import React from 'react';
import { facturacionAPI } from '../services/api';
import { toast } from 'react-toastify';

export function FacturaMovimientoMarca({ mov, puedePdf }) {
  if (!mov?.factura_id) return null;
  if (mov.factura_estado === 'pendiente') {
    return <span className="factura-mov-marca">Factura pendiente</span>;
  }
  if (mov.factura_estado !== 'aprobada') return null;

  const abrir = async () => {
    try {
      await facturacionAPI.abrirPdf(mov.factura_id);
    } catch (error) {
      toast.error(error.message || 'No se pudo abrir el PDF');
    }
  };

  return (
    <>
      <span className="factura-mov-marca">Facturada</span>
      {puedePdf && mov.factura_cae && (
        <button type="button" className="btn-action-icon factura-mov-pdf" title="PDF de la factura" onClick={abrir}>
          PDF
        </button>
      )}
    </>
  );
}
